import { Injectable } from '@angular/core';
import { ApiService } from '../core/services/api.service';
import { Observable } from 'rxjs';
import { ICountry } from './types';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    constructor(private apiService: ApiService) { }

    public fetchCountries(): Observable<ICountry[]> {
        return this.apiService.get('/countries')
            .pipe(map(result => result.countries));
    }

    public fetchNotifications(data: { page: number }): Observable<any> {
        return this.apiService.get('/notifications/getAllSignupNotifications', data);
    }

    public markNotificationsAsRead(): Observable<any> {
        return this.apiService.post('/notifications/markSignupNotificationAsRead', {});
    }

}
